import { helpers } from "vuelidate/lib/validators";

export const oneWordValidator = helpers.regex("oneWordValidator", /^\S+$/m);